import { Component, OnInit } from '@angular/core';
import { HallService } from '@services/hall.service';
import { SeoService } from '@services/seo.service';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-hall-list',
  templateUrl: './hall-list.component.html',
  styleUrls: ['./hall-list.component.scss']
})
export class HallListComponent implements OnInit {
	private sub: any;
	halls: any = [];
    kindOfHalls: string;
    citySlug: string;
    headerOne: string;
    kindLabel: string;

    constructor(
        private activatedRoute: ActivatedRoute,
        private hallService: HallService,
        private seoService: SeoService,
    ) { }

    ngOnInit(): void {
        const urlSegment = this.activatedRoute.snapshot.url[0].path;
        switch (urlSegment) {
            case 'wettbueros':
                this.kindOfHalls = 'wettbuero';
                this.kindLabel = 'Wettbüros';
                this.headerOne = 'Wettbüros in ';
                break;
            case 'automaten':
                this.kindOfHalls = 'automaten';
                this.kindLabel = 'Automaten';
                this.headerOne = 'Automaten in ';
                break;
            default:
                this.kindOfHalls = 'spielhalle';
                this.kindLabel = 'Spielhallen';
                this.headerOne = 'Spielhallen in ';
                break;
        };

        this.sub = this.activatedRoute.params.subscribe(params => {
            this.citySlug = params['cityslug'];
        });

        this.hallService.getHalls({ kind: this.kindOfHalls, cityslug: this.citySlug})
            .subscribe(data => {
                console.log(data)
                this.halls = data;
                this.headerOne = this.headerOne + this.halls[0].cityname;

                const cityname = this.halls[0].cityname;
                this.seoService.set({
                    title: `${this.kindLabel} in ${cityname} | Spieloguide`,
                    description: `${this.kindLabel} in ${cityname} finden – Adressen, Öffnungszeiten und Anfahrt auf Spieloguide.`,
                    path: `/${urlSegment}/stadt/${this.citySlug}`
                });
            });
    };

}
